import PhotoSize from '@alltrails/types/PhotoSize';
import { getStaticMapScale } from '@alltrails/types/staticMapScale';
import StaticMapSize from '@alltrails/types/StaticMapSize';

export const getTrailProfilePhoto = (id: string | number, size: PhotoSize, staticMapSize: StaticMapSize, urlBase = '') =>
  `${urlBase}/api/alltrails/v3/trails/${id}/profile_photo?show_placeholder=no&size=${size}&static_map_size=${staticMapSize}&static_map_scale=${getStaticMapScale(staticMapSize)}&key=${process.env.NEXT_PUBLIC_TRAIL_PHOTO_API_KEY}`;
